var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('v-snackbar',{attrs:{"top":true,"multi-line":true,"timeout":10000},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.text))]),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":_vm.close}},[_vm._v("Закрыть")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }